/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Header from "../../CommonComponents/header";
import { Footer } from "../../CommonComponents/footer";
import { GetInTouchSection } from "./Components/getInTouchSection";
import { MobileHeader } from "../../CommonComponents/mobileHeader";
import { BlogHeroSection } from "../BlogsPage/Components/blogHeroSection";
import { MainHeading } from "../../subComponents/MainHeading";

function ContactUsPage() {
  return (
    <>
      <Header />
      <MobileHeader />
      <div className="mobile_header_spacer_home"></div>
      <div className="desktop_header_spacer"></div>
      {/* <ContactHeroSection /> */}
      <BlogHeroSection
        pagetitle={"Contact Us"}
        imageUrl={"/assets/images/new_images/banners/blog_banner.jpg"}
        white={"black"}
      />
      <GetInTouchSection />
      <section className="contact_map_section">
        <MainHeading title={"Find us on google map"} />
        <br />
        <div className="contact_map_container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7040.379049104367!2d77.42601856361546!3d28.079761256053384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397333254b559af9%3A0x494a9ad40bda168!2sBadoli%2C%20Haryana%20121102!5e0!3m2!1sen!2sin!4v1769604487683!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{ border: "0" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>

          {/* <iframe src="" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
        </div>
      </section>
      <Footer />
    </>
  );
}
export default ContactUsPage;
